/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ConsoleImport } from './routes/console'
import { Route as IndexImport } from './routes/index'
import { Route as ConsoleIndexImport } from './routes/console/index'
import { Route as ConsoleNoPermissionImport } from './routes/console/no-permission'
import { Route as ConsoleDashboardImport } from './routes/console/dashboard'
import { Route as publicPublicImport } from './routes/(public)/_public'
import { Route as ConsoleSitesListImport } from './routes/console/sites/list'
import { Route as ConsoleSitesAddImport } from './routes/console/sites/add'
import { Route as ConsoleRolesListImport } from './routes/console/roles/list'
import { Route as ConsoleRolesAssignImport } from './routes/console/roles/assign'
import { Route as ConsoleRolesAddImport } from './routes/console/roles/add'
import { Route as ConsoleQrListImport } from './routes/console/qr/list'
import { Route as ConsoleOperatorGroupsListImport } from './routes/console/operator-groups/list'
import { Route as ConsoleOperatorGroupsAddImport } from './routes/console/operator-groups/add'
import { Route as ConsoleIntegratorListImport } from './routes/console/integrator/list'
import { Route as ConsoleIntegratorAddImport } from './routes/console/integrator/add'
import { Route as ConsoleDivisionsListImport } from './routes/console/divisions/list'
import { Route as ConsoleDistributorListImport } from './routes/console/distributor/list'
import { Route as ConsoleDistributorAddImport } from './routes/console/distributor/add'
import { Route as publicPublicSignInImport } from './routes/(public)/_public/sign-in'
import { Route as publicPublicResetPasswordImport } from './routes/(public)/_public/reset-password'
import { Route as publicPublicForgotPasswordImport } from './routes/(public)/_public/forgot-password'
import { Route as ConsoleSitesLicensesListImport } from './routes/console/sites/licenses/list'
import { Route as ConsoleSitesLicensesAddImport } from './routes/console/sites/licenses/add'
import { Route as ConsoleSitesEditIdImport } from './routes/console/sites/edit/$id'
import { Route as ConsoleRolesEditIdImport } from './routes/console/roles/edit/$id'
import { Route as ConsoleProductsTemplatesListImport } from './routes/console/products/templates/list'
import { Route as ConsoleProductsTemplatesAddImport } from './routes/console/products/templates/add'
import { Route as ConsoleProductsPrivilegesListImport } from './routes/console/products/privileges/list'
import { Route as ConsoleProductsFeaturesListImport } from './routes/console/products/features/list'
import { Route as ConsoleProductsFeaturesAddImport } from './routes/console/products/features/add'
import { Route as ConsoleOperatorGroupsEditIdImport } from './routes/console/operator-groups/edit/$id'
import { Route as ConsoleIntegratorEditIdImport } from './routes/console/integrator/edit/$id'
import { Route as ConsoleDistributorEditIdImport } from './routes/console/distributor/edit/$id'
import { Route as ConsoleSitesLicensesEditIdImport } from './routes/console/sites/licenses/edit/$id'
import { Route as ConsoleSitesLicensesDuplicateIdImport } from './routes/console/sites/licenses/duplicate/$id'
import { Route as ConsoleProductsTemplatesEditIdImport } from './routes/console/products/templates/edit/$id'
import { Route as ConsoleProductsTemplatesDuplicateIdImport } from './routes/console/products/templates/duplicate/$id'
import { Route as ConsoleProductsFeaturesEditIdImport } from './routes/console/products/features/edit/$id'

// Create Virtual Routes

const publicImport = createFileRoute('/(public)')()

// Create/Update Routes

const publicRoute = publicImport.update({
  id: '/(public)',
  getParentRoute: () => rootRoute,
} as any)

const ConsoleRoute = ConsoleImport.update({
  id: '/console',
  path: '/console',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ConsoleIndexRoute = ConsoleIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleNoPermissionRoute = ConsoleNoPermissionImport.update({
  id: '/no-permission',
  path: '/no-permission',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleDashboardRoute = ConsoleDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ConsoleRoute,
} as any).lazy(() =>
  import('./routes/console/dashboard.lazy').then((d) => d.Route),
)

const publicPublicRoute = publicPublicImport.update({
  id: '/_public',
  getParentRoute: () => publicRoute,
} as any)

const ConsoleSitesListRoute = ConsoleSitesListImport.update({
  id: '/sites/list',
  path: '/sites/list',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleSitesAddRoute = ConsoleSitesAddImport.update({
  id: '/sites/add',
  path: '/sites/add',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleRolesListRoute = ConsoleRolesListImport.update({
  id: '/roles/list',
  path: '/roles/list',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleRolesAssignRoute = ConsoleRolesAssignImport.update({
  id: '/roles/assign',
  path: '/roles/assign',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleRolesAddRoute = ConsoleRolesAddImport.update({
  id: '/roles/add',
  path: '/roles/add',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleQrListRoute = ConsoleQrListImport.update({
  id: '/qr/list',
  path: '/qr/list',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleOperatorGroupsListRoute = ConsoleOperatorGroupsListImport.update({
  id: '/operator-groups/list',
  path: '/operator-groups/list',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleOperatorGroupsAddRoute = ConsoleOperatorGroupsAddImport.update({
  id: '/operator-groups/add',
  path: '/operator-groups/add',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleIntegratorListRoute = ConsoleIntegratorListImport.update({
  id: '/integrator/list',
  path: '/integrator/list',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleIntegratorAddRoute = ConsoleIntegratorAddImport.update({
  id: '/integrator/add',
  path: '/integrator/add',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleDivisionsListRoute = ConsoleDivisionsListImport.update({
  id: '/divisions/list',
  path: '/divisions/list',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleDistributorListRoute = ConsoleDistributorListImport.update({
  id: '/distributor/list',
  path: '/distributor/list',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleDistributorAddRoute = ConsoleDistributorAddImport.update({
  id: '/distributor/add',
  path: '/distributor/add',
  getParentRoute: () => ConsoleRoute,
} as any)

const publicPublicSignInRoute = publicPublicSignInImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicResetPasswordRoute = publicPublicResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicForgotPasswordRoute = publicPublicForgotPasswordImport.update(
  {
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => publicPublicRoute,
  } as any,
)

const ConsoleSitesLicensesListRoute = ConsoleSitesLicensesListImport.update({
  id: '/sites/licenses/list',
  path: '/sites/licenses/list',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleSitesLicensesAddRoute = ConsoleSitesLicensesAddImport.update({
  id: '/sites/licenses/add',
  path: '/sites/licenses/add',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleSitesEditIdRoute = ConsoleSitesEditIdImport.update({
  id: '/sites/edit/$id',
  path: '/sites/edit/$id',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleRolesEditIdRoute = ConsoleRolesEditIdImport.update({
  id: '/roles/edit/$id',
  path: '/roles/edit/$id',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleProductsTemplatesListRoute =
  ConsoleProductsTemplatesListImport.update({
    id: '/products/templates/list',
    path: '/products/templates/list',
    getParentRoute: () => ConsoleRoute,
  } as any)

const ConsoleProductsTemplatesAddRoute =
  ConsoleProductsTemplatesAddImport.update({
    id: '/products/templates/add',
    path: '/products/templates/add',
    getParentRoute: () => ConsoleRoute,
  } as any)

const ConsoleProductsPrivilegesListRoute =
  ConsoleProductsPrivilegesListImport.update({
    id: '/products/privileges/list',
    path: '/products/privileges/list',
    getParentRoute: () => ConsoleRoute,
  } as any)

const ConsoleProductsFeaturesListRoute =
  ConsoleProductsFeaturesListImport.update({
    id: '/products/features/list',
    path: '/products/features/list',
    getParentRoute: () => ConsoleRoute,
  } as any)

const ConsoleProductsFeaturesAddRoute = ConsoleProductsFeaturesAddImport.update(
  {
    id: '/products/features/add',
    path: '/products/features/add',
    getParentRoute: () => ConsoleRoute,
  } as any,
)

const ConsoleOperatorGroupsEditIdRoute =
  ConsoleOperatorGroupsEditIdImport.update({
    id: '/operator-groups/edit/$id',
    path: '/operator-groups/edit/$id',
    getParentRoute: () => ConsoleRoute,
  } as any)

const ConsoleIntegratorEditIdRoute = ConsoleIntegratorEditIdImport.update({
  id: '/integrator/edit/$id',
  path: '/integrator/edit/$id',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleDistributorEditIdRoute = ConsoleDistributorEditIdImport.update({
  id: '/distributor/edit/$id',
  path: '/distributor/edit/$id',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleSitesLicensesEditIdRoute = ConsoleSitesLicensesEditIdImport.update(
  {
    id: '/sites/licenses/edit/$id',
    path: '/sites/licenses/edit/$id',
    getParentRoute: () => ConsoleRoute,
  } as any,
)

const ConsoleSitesLicensesDuplicateIdRoute =
  ConsoleSitesLicensesDuplicateIdImport.update({
    id: '/sites/licenses/duplicate/$id',
    path: '/sites/licenses/duplicate/$id',
    getParentRoute: () => ConsoleRoute,
  } as any)

const ConsoleProductsTemplatesEditIdRoute =
  ConsoleProductsTemplatesEditIdImport.update({
    id: '/products/templates/edit/$id',
    path: '/products/templates/edit/$id',
    getParentRoute: () => ConsoleRoute,
  } as any)

const ConsoleProductsTemplatesDuplicateIdRoute =
  ConsoleProductsTemplatesDuplicateIdImport.update({
    id: '/products/templates/duplicate/$id',
    path: '/products/templates/duplicate/$id',
    getParentRoute: () => ConsoleRoute,
  } as any)

const ConsoleProductsFeaturesEditIdRoute =
  ConsoleProductsFeaturesEditIdImport.update({
    id: '/products/features/edit/$id',
    path: '/products/features/edit/$id',
    getParentRoute: () => ConsoleRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/console': {
      id: '/console'
      path: '/console'
      fullPath: '/console'
      preLoaderRoute: typeof ConsoleImport
      parentRoute: typeof rootRoute
    }
    '/(public)': {
      id: '/(public)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicImport
      parentRoute: typeof rootRoute
    }
    '/(public)/_public': {
      id: '/(public)/_public'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicImport
      parentRoute: typeof publicRoute
    }
    '/console/dashboard': {
      id: '/console/dashboard'
      path: '/dashboard'
      fullPath: '/console/dashboard'
      preLoaderRoute: typeof ConsoleDashboardImport
      parentRoute: typeof ConsoleImport
    }
    '/console/no-permission': {
      id: '/console/no-permission'
      path: '/no-permission'
      fullPath: '/console/no-permission'
      preLoaderRoute: typeof ConsoleNoPermissionImport
      parentRoute: typeof ConsoleImport
    }
    '/console/': {
      id: '/console/'
      path: '/'
      fullPath: '/console/'
      preLoaderRoute: typeof ConsoleIndexImport
      parentRoute: typeof ConsoleImport
    }
    '/(public)/_public/forgot-password': {
      id: '/(public)/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof publicPublicForgotPasswordImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/reset-password': {
      id: '/(public)/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof publicPublicResetPasswordImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/sign-in': {
      id: '/(public)/_public/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof publicPublicSignInImport
      parentRoute: typeof publicPublicImport
    }
    '/console/distributor/add': {
      id: '/console/distributor/add'
      path: '/distributor/add'
      fullPath: '/console/distributor/add'
      preLoaderRoute: typeof ConsoleDistributorAddImport
      parentRoute: typeof ConsoleImport
    }
    '/console/distributor/list': {
      id: '/console/distributor/list'
      path: '/distributor/list'
      fullPath: '/console/distributor/list'
      preLoaderRoute: typeof ConsoleDistributorListImport
      parentRoute: typeof ConsoleImport
    }
    '/console/divisions/list': {
      id: '/console/divisions/list'
      path: '/divisions/list'
      fullPath: '/console/divisions/list'
      preLoaderRoute: typeof ConsoleDivisionsListImport
      parentRoute: typeof ConsoleImport
    }
    '/console/integrator/add': {
      id: '/console/integrator/add'
      path: '/integrator/add'
      fullPath: '/console/integrator/add'
      preLoaderRoute: typeof ConsoleIntegratorAddImport
      parentRoute: typeof ConsoleImport
    }
    '/console/integrator/list': {
      id: '/console/integrator/list'
      path: '/integrator/list'
      fullPath: '/console/integrator/list'
      preLoaderRoute: typeof ConsoleIntegratorListImport
      parentRoute: typeof ConsoleImport
    }
    '/console/operator-groups/add': {
      id: '/console/operator-groups/add'
      path: '/operator-groups/add'
      fullPath: '/console/operator-groups/add'
      preLoaderRoute: typeof ConsoleOperatorGroupsAddImport
      parentRoute: typeof ConsoleImport
    }
    '/console/operator-groups/list': {
      id: '/console/operator-groups/list'
      path: '/operator-groups/list'
      fullPath: '/console/operator-groups/list'
      preLoaderRoute: typeof ConsoleOperatorGroupsListImport
      parentRoute: typeof ConsoleImport
    }
    '/console/qr/list': {
      id: '/console/qr/list'
      path: '/qr/list'
      fullPath: '/console/qr/list'
      preLoaderRoute: typeof ConsoleQrListImport
      parentRoute: typeof ConsoleImport
    }
    '/console/roles/add': {
      id: '/console/roles/add'
      path: '/roles/add'
      fullPath: '/console/roles/add'
      preLoaderRoute: typeof ConsoleRolesAddImport
      parentRoute: typeof ConsoleImport
    }
    '/console/roles/assign': {
      id: '/console/roles/assign'
      path: '/roles/assign'
      fullPath: '/console/roles/assign'
      preLoaderRoute: typeof ConsoleRolesAssignImport
      parentRoute: typeof ConsoleImport
    }
    '/console/roles/list': {
      id: '/console/roles/list'
      path: '/roles/list'
      fullPath: '/console/roles/list'
      preLoaderRoute: typeof ConsoleRolesListImport
      parentRoute: typeof ConsoleImport
    }
    '/console/sites/add': {
      id: '/console/sites/add'
      path: '/sites/add'
      fullPath: '/console/sites/add'
      preLoaderRoute: typeof ConsoleSitesAddImport
      parentRoute: typeof ConsoleImport
    }
    '/console/sites/list': {
      id: '/console/sites/list'
      path: '/sites/list'
      fullPath: '/console/sites/list'
      preLoaderRoute: typeof ConsoleSitesListImport
      parentRoute: typeof ConsoleImport
    }
    '/console/distributor/edit/$id': {
      id: '/console/distributor/edit/$id'
      path: '/distributor/edit/$id'
      fullPath: '/console/distributor/edit/$id'
      preLoaderRoute: typeof ConsoleDistributorEditIdImport
      parentRoute: typeof ConsoleImport
    }
    '/console/integrator/edit/$id': {
      id: '/console/integrator/edit/$id'
      path: '/integrator/edit/$id'
      fullPath: '/console/integrator/edit/$id'
      preLoaderRoute: typeof ConsoleIntegratorEditIdImport
      parentRoute: typeof ConsoleImport
    }
    '/console/operator-groups/edit/$id': {
      id: '/console/operator-groups/edit/$id'
      path: '/operator-groups/edit/$id'
      fullPath: '/console/operator-groups/edit/$id'
      preLoaderRoute: typeof ConsoleOperatorGroupsEditIdImport
      parentRoute: typeof ConsoleImport
    }
    '/console/products/features/add': {
      id: '/console/products/features/add'
      path: '/products/features/add'
      fullPath: '/console/products/features/add'
      preLoaderRoute: typeof ConsoleProductsFeaturesAddImport
      parentRoute: typeof ConsoleImport
    }
    '/console/products/features/list': {
      id: '/console/products/features/list'
      path: '/products/features/list'
      fullPath: '/console/products/features/list'
      preLoaderRoute: typeof ConsoleProductsFeaturesListImport
      parentRoute: typeof ConsoleImport
    }
    '/console/products/privileges/list': {
      id: '/console/products/privileges/list'
      path: '/products/privileges/list'
      fullPath: '/console/products/privileges/list'
      preLoaderRoute: typeof ConsoleProductsPrivilegesListImport
      parentRoute: typeof ConsoleImport
    }
    '/console/products/templates/add': {
      id: '/console/products/templates/add'
      path: '/products/templates/add'
      fullPath: '/console/products/templates/add'
      preLoaderRoute: typeof ConsoleProductsTemplatesAddImport
      parentRoute: typeof ConsoleImport
    }
    '/console/products/templates/list': {
      id: '/console/products/templates/list'
      path: '/products/templates/list'
      fullPath: '/console/products/templates/list'
      preLoaderRoute: typeof ConsoleProductsTemplatesListImport
      parentRoute: typeof ConsoleImport
    }
    '/console/roles/edit/$id': {
      id: '/console/roles/edit/$id'
      path: '/roles/edit/$id'
      fullPath: '/console/roles/edit/$id'
      preLoaderRoute: typeof ConsoleRolesEditIdImport
      parentRoute: typeof ConsoleImport
    }
    '/console/sites/edit/$id': {
      id: '/console/sites/edit/$id'
      path: '/sites/edit/$id'
      fullPath: '/console/sites/edit/$id'
      preLoaderRoute: typeof ConsoleSitesEditIdImport
      parentRoute: typeof ConsoleImport
    }
    '/console/sites/licenses/add': {
      id: '/console/sites/licenses/add'
      path: '/sites/licenses/add'
      fullPath: '/console/sites/licenses/add'
      preLoaderRoute: typeof ConsoleSitesLicensesAddImport
      parentRoute: typeof ConsoleImport
    }
    '/console/sites/licenses/list': {
      id: '/console/sites/licenses/list'
      path: '/sites/licenses/list'
      fullPath: '/console/sites/licenses/list'
      preLoaderRoute: typeof ConsoleSitesLicensesListImport
      parentRoute: typeof ConsoleImport
    }
    '/console/products/features/edit/$id': {
      id: '/console/products/features/edit/$id'
      path: '/products/features/edit/$id'
      fullPath: '/console/products/features/edit/$id'
      preLoaderRoute: typeof ConsoleProductsFeaturesEditIdImport
      parentRoute: typeof ConsoleImport
    }
    '/console/products/templates/duplicate/$id': {
      id: '/console/products/templates/duplicate/$id'
      path: '/products/templates/duplicate/$id'
      fullPath: '/console/products/templates/duplicate/$id'
      preLoaderRoute: typeof ConsoleProductsTemplatesDuplicateIdImport
      parentRoute: typeof ConsoleImport
    }
    '/console/products/templates/edit/$id': {
      id: '/console/products/templates/edit/$id'
      path: '/products/templates/edit/$id'
      fullPath: '/console/products/templates/edit/$id'
      preLoaderRoute: typeof ConsoleProductsTemplatesEditIdImport
      parentRoute: typeof ConsoleImport
    }
    '/console/sites/licenses/duplicate/$id': {
      id: '/console/sites/licenses/duplicate/$id'
      path: '/sites/licenses/duplicate/$id'
      fullPath: '/console/sites/licenses/duplicate/$id'
      preLoaderRoute: typeof ConsoleSitesLicensesDuplicateIdImport
      parentRoute: typeof ConsoleImport
    }
    '/console/sites/licenses/edit/$id': {
      id: '/console/sites/licenses/edit/$id'
      path: '/sites/licenses/edit/$id'
      fullPath: '/console/sites/licenses/edit/$id'
      preLoaderRoute: typeof ConsoleSitesLicensesEditIdImport
      parentRoute: typeof ConsoleImport
    }
  }
}

// Create and export the route tree

interface ConsoleRouteChildren {
  ConsoleDashboardRoute: typeof ConsoleDashboardRoute
  ConsoleNoPermissionRoute: typeof ConsoleNoPermissionRoute
  ConsoleIndexRoute: typeof ConsoleIndexRoute
  ConsoleDistributorAddRoute: typeof ConsoleDistributorAddRoute
  ConsoleDistributorListRoute: typeof ConsoleDistributorListRoute
  ConsoleDivisionsListRoute: typeof ConsoleDivisionsListRoute
  ConsoleIntegratorAddRoute: typeof ConsoleIntegratorAddRoute
  ConsoleIntegratorListRoute: typeof ConsoleIntegratorListRoute
  ConsoleOperatorGroupsAddRoute: typeof ConsoleOperatorGroupsAddRoute
  ConsoleOperatorGroupsListRoute: typeof ConsoleOperatorGroupsListRoute
  ConsoleQrListRoute: typeof ConsoleQrListRoute
  ConsoleRolesAddRoute: typeof ConsoleRolesAddRoute
  ConsoleRolesAssignRoute: typeof ConsoleRolesAssignRoute
  ConsoleRolesListRoute: typeof ConsoleRolesListRoute
  ConsoleSitesAddRoute: typeof ConsoleSitesAddRoute
  ConsoleSitesListRoute: typeof ConsoleSitesListRoute
  ConsoleDistributorEditIdRoute: typeof ConsoleDistributorEditIdRoute
  ConsoleIntegratorEditIdRoute: typeof ConsoleIntegratorEditIdRoute
  ConsoleOperatorGroupsEditIdRoute: typeof ConsoleOperatorGroupsEditIdRoute
  ConsoleProductsFeaturesAddRoute: typeof ConsoleProductsFeaturesAddRoute
  ConsoleProductsFeaturesListRoute: typeof ConsoleProductsFeaturesListRoute
  ConsoleProductsPrivilegesListRoute: typeof ConsoleProductsPrivilegesListRoute
  ConsoleProductsTemplatesAddRoute: typeof ConsoleProductsTemplatesAddRoute
  ConsoleProductsTemplatesListRoute: typeof ConsoleProductsTemplatesListRoute
  ConsoleRolesEditIdRoute: typeof ConsoleRolesEditIdRoute
  ConsoleSitesEditIdRoute: typeof ConsoleSitesEditIdRoute
  ConsoleSitesLicensesAddRoute: typeof ConsoleSitesLicensesAddRoute
  ConsoleSitesLicensesListRoute: typeof ConsoleSitesLicensesListRoute
  ConsoleProductsFeaturesEditIdRoute: typeof ConsoleProductsFeaturesEditIdRoute
  ConsoleProductsTemplatesDuplicateIdRoute: typeof ConsoleProductsTemplatesDuplicateIdRoute
  ConsoleProductsTemplatesEditIdRoute: typeof ConsoleProductsTemplatesEditIdRoute
  ConsoleSitesLicensesDuplicateIdRoute: typeof ConsoleSitesLicensesDuplicateIdRoute
  ConsoleSitesLicensesEditIdRoute: typeof ConsoleSitesLicensesEditIdRoute
}

const ConsoleRouteChildren: ConsoleRouteChildren = {
  ConsoleDashboardRoute: ConsoleDashboardRoute,
  ConsoleNoPermissionRoute: ConsoleNoPermissionRoute,
  ConsoleIndexRoute: ConsoleIndexRoute,
  ConsoleDistributorAddRoute: ConsoleDistributorAddRoute,
  ConsoleDistributorListRoute: ConsoleDistributorListRoute,
  ConsoleDivisionsListRoute: ConsoleDivisionsListRoute,
  ConsoleIntegratorAddRoute: ConsoleIntegratorAddRoute,
  ConsoleIntegratorListRoute: ConsoleIntegratorListRoute,
  ConsoleOperatorGroupsAddRoute: ConsoleOperatorGroupsAddRoute,
  ConsoleOperatorGroupsListRoute: ConsoleOperatorGroupsListRoute,
  ConsoleQrListRoute: ConsoleQrListRoute,
  ConsoleRolesAddRoute: ConsoleRolesAddRoute,
  ConsoleRolesAssignRoute: ConsoleRolesAssignRoute,
  ConsoleRolesListRoute: ConsoleRolesListRoute,
  ConsoleSitesAddRoute: ConsoleSitesAddRoute,
  ConsoleSitesListRoute: ConsoleSitesListRoute,
  ConsoleDistributorEditIdRoute: ConsoleDistributorEditIdRoute,
  ConsoleIntegratorEditIdRoute: ConsoleIntegratorEditIdRoute,
  ConsoleOperatorGroupsEditIdRoute: ConsoleOperatorGroupsEditIdRoute,
  ConsoleProductsFeaturesAddRoute: ConsoleProductsFeaturesAddRoute,
  ConsoleProductsFeaturesListRoute: ConsoleProductsFeaturesListRoute,
  ConsoleProductsPrivilegesListRoute: ConsoleProductsPrivilegesListRoute,
  ConsoleProductsTemplatesAddRoute: ConsoleProductsTemplatesAddRoute,
  ConsoleProductsTemplatesListRoute: ConsoleProductsTemplatesListRoute,
  ConsoleRolesEditIdRoute: ConsoleRolesEditIdRoute,
  ConsoleSitesEditIdRoute: ConsoleSitesEditIdRoute,
  ConsoleSitesLicensesAddRoute: ConsoleSitesLicensesAddRoute,
  ConsoleSitesLicensesListRoute: ConsoleSitesLicensesListRoute,
  ConsoleProductsFeaturesEditIdRoute: ConsoleProductsFeaturesEditIdRoute,
  ConsoleProductsTemplatesDuplicateIdRoute:
    ConsoleProductsTemplatesDuplicateIdRoute,
  ConsoleProductsTemplatesEditIdRoute: ConsoleProductsTemplatesEditIdRoute,
  ConsoleSitesLicensesDuplicateIdRoute: ConsoleSitesLicensesDuplicateIdRoute,
  ConsoleSitesLicensesEditIdRoute: ConsoleSitesLicensesEditIdRoute,
}

const ConsoleRouteWithChildren =
  ConsoleRoute._addFileChildren(ConsoleRouteChildren)

interface publicPublicRouteChildren {
  publicPublicForgotPasswordRoute: typeof publicPublicForgotPasswordRoute
  publicPublicResetPasswordRoute: typeof publicPublicResetPasswordRoute
  publicPublicSignInRoute: typeof publicPublicSignInRoute
}

const publicPublicRouteChildren: publicPublicRouteChildren = {
  publicPublicForgotPasswordRoute: publicPublicForgotPasswordRoute,
  publicPublicResetPasswordRoute: publicPublicResetPasswordRoute,
  publicPublicSignInRoute: publicPublicSignInRoute,
}

const publicPublicRouteWithChildren = publicPublicRoute._addFileChildren(
  publicPublicRouteChildren,
)

interface publicRouteChildren {
  publicPublicRoute: typeof publicPublicRouteWithChildren
}

const publicRouteChildren: publicRouteChildren = {
  publicPublicRoute: publicPublicRouteWithChildren,
}

const publicRouteWithChildren =
  publicRoute._addFileChildren(publicRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof publicPublicRouteWithChildren
  '/console': typeof ConsoleRouteWithChildren
  '/console/dashboard': typeof ConsoleDashboardRoute
  '/console/no-permission': typeof ConsoleNoPermissionRoute
  '/console/': typeof ConsoleIndexRoute
  '/forgot-password': typeof publicPublicForgotPasswordRoute
  '/reset-password': typeof publicPublicResetPasswordRoute
  '/sign-in': typeof publicPublicSignInRoute
  '/console/distributor/add': typeof ConsoleDistributorAddRoute
  '/console/distributor/list': typeof ConsoleDistributorListRoute
  '/console/divisions/list': typeof ConsoleDivisionsListRoute
  '/console/integrator/add': typeof ConsoleIntegratorAddRoute
  '/console/integrator/list': typeof ConsoleIntegratorListRoute
  '/console/operator-groups/add': typeof ConsoleOperatorGroupsAddRoute
  '/console/operator-groups/list': typeof ConsoleOperatorGroupsListRoute
  '/console/qr/list': typeof ConsoleQrListRoute
  '/console/roles/add': typeof ConsoleRolesAddRoute
  '/console/roles/assign': typeof ConsoleRolesAssignRoute
  '/console/roles/list': typeof ConsoleRolesListRoute
  '/console/sites/add': typeof ConsoleSitesAddRoute
  '/console/sites/list': typeof ConsoleSitesListRoute
  '/console/distributor/edit/$id': typeof ConsoleDistributorEditIdRoute
  '/console/integrator/edit/$id': typeof ConsoleIntegratorEditIdRoute
  '/console/operator-groups/edit/$id': typeof ConsoleOperatorGroupsEditIdRoute
  '/console/products/features/add': typeof ConsoleProductsFeaturesAddRoute
  '/console/products/features/list': typeof ConsoleProductsFeaturesListRoute
  '/console/products/privileges/list': typeof ConsoleProductsPrivilegesListRoute
  '/console/products/templates/add': typeof ConsoleProductsTemplatesAddRoute
  '/console/products/templates/list': typeof ConsoleProductsTemplatesListRoute
  '/console/roles/edit/$id': typeof ConsoleRolesEditIdRoute
  '/console/sites/edit/$id': typeof ConsoleSitesEditIdRoute
  '/console/sites/licenses/add': typeof ConsoleSitesLicensesAddRoute
  '/console/sites/licenses/list': typeof ConsoleSitesLicensesListRoute
  '/console/products/features/edit/$id': typeof ConsoleProductsFeaturesEditIdRoute
  '/console/products/templates/duplicate/$id': typeof ConsoleProductsTemplatesDuplicateIdRoute
  '/console/products/templates/edit/$id': typeof ConsoleProductsTemplatesEditIdRoute
  '/console/sites/licenses/duplicate/$id': typeof ConsoleSitesLicensesDuplicateIdRoute
  '/console/sites/licenses/edit/$id': typeof ConsoleSitesLicensesEditIdRoute
}

export interface FileRoutesByTo {
  '/': typeof publicPublicRouteWithChildren
  '/console/dashboard': typeof ConsoleDashboardRoute
  '/console/no-permission': typeof ConsoleNoPermissionRoute
  '/console': typeof ConsoleIndexRoute
  '/forgot-password': typeof publicPublicForgotPasswordRoute
  '/reset-password': typeof publicPublicResetPasswordRoute
  '/sign-in': typeof publicPublicSignInRoute
  '/console/distributor/add': typeof ConsoleDistributorAddRoute
  '/console/distributor/list': typeof ConsoleDistributorListRoute
  '/console/divisions/list': typeof ConsoleDivisionsListRoute
  '/console/integrator/add': typeof ConsoleIntegratorAddRoute
  '/console/integrator/list': typeof ConsoleIntegratorListRoute
  '/console/operator-groups/add': typeof ConsoleOperatorGroupsAddRoute
  '/console/operator-groups/list': typeof ConsoleOperatorGroupsListRoute
  '/console/qr/list': typeof ConsoleQrListRoute
  '/console/roles/add': typeof ConsoleRolesAddRoute
  '/console/roles/assign': typeof ConsoleRolesAssignRoute
  '/console/roles/list': typeof ConsoleRolesListRoute
  '/console/sites/add': typeof ConsoleSitesAddRoute
  '/console/sites/list': typeof ConsoleSitesListRoute
  '/console/distributor/edit/$id': typeof ConsoleDistributorEditIdRoute
  '/console/integrator/edit/$id': typeof ConsoleIntegratorEditIdRoute
  '/console/operator-groups/edit/$id': typeof ConsoleOperatorGroupsEditIdRoute
  '/console/products/features/add': typeof ConsoleProductsFeaturesAddRoute
  '/console/products/features/list': typeof ConsoleProductsFeaturesListRoute
  '/console/products/privileges/list': typeof ConsoleProductsPrivilegesListRoute
  '/console/products/templates/add': typeof ConsoleProductsTemplatesAddRoute
  '/console/products/templates/list': typeof ConsoleProductsTemplatesListRoute
  '/console/roles/edit/$id': typeof ConsoleRolesEditIdRoute
  '/console/sites/edit/$id': typeof ConsoleSitesEditIdRoute
  '/console/sites/licenses/add': typeof ConsoleSitesLicensesAddRoute
  '/console/sites/licenses/list': typeof ConsoleSitesLicensesListRoute
  '/console/products/features/edit/$id': typeof ConsoleProductsFeaturesEditIdRoute
  '/console/products/templates/duplicate/$id': typeof ConsoleProductsTemplatesDuplicateIdRoute
  '/console/products/templates/edit/$id': typeof ConsoleProductsTemplatesEditIdRoute
  '/console/sites/licenses/duplicate/$id': typeof ConsoleSitesLicensesDuplicateIdRoute
  '/console/sites/licenses/edit/$id': typeof ConsoleSitesLicensesEditIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/console': typeof ConsoleRouteWithChildren
  '/(public)': typeof publicRouteWithChildren
  '/(public)/_public': typeof publicPublicRouteWithChildren
  '/console/dashboard': typeof ConsoleDashboardRoute
  '/console/no-permission': typeof ConsoleNoPermissionRoute
  '/console/': typeof ConsoleIndexRoute
  '/(public)/_public/forgot-password': typeof publicPublicForgotPasswordRoute
  '/(public)/_public/reset-password': typeof publicPublicResetPasswordRoute
  '/(public)/_public/sign-in': typeof publicPublicSignInRoute
  '/console/distributor/add': typeof ConsoleDistributorAddRoute
  '/console/distributor/list': typeof ConsoleDistributorListRoute
  '/console/divisions/list': typeof ConsoleDivisionsListRoute
  '/console/integrator/add': typeof ConsoleIntegratorAddRoute
  '/console/integrator/list': typeof ConsoleIntegratorListRoute
  '/console/operator-groups/add': typeof ConsoleOperatorGroupsAddRoute
  '/console/operator-groups/list': typeof ConsoleOperatorGroupsListRoute
  '/console/qr/list': typeof ConsoleQrListRoute
  '/console/roles/add': typeof ConsoleRolesAddRoute
  '/console/roles/assign': typeof ConsoleRolesAssignRoute
  '/console/roles/list': typeof ConsoleRolesListRoute
  '/console/sites/add': typeof ConsoleSitesAddRoute
  '/console/sites/list': typeof ConsoleSitesListRoute
  '/console/distributor/edit/$id': typeof ConsoleDistributorEditIdRoute
  '/console/integrator/edit/$id': typeof ConsoleIntegratorEditIdRoute
  '/console/operator-groups/edit/$id': typeof ConsoleOperatorGroupsEditIdRoute
  '/console/products/features/add': typeof ConsoleProductsFeaturesAddRoute
  '/console/products/features/list': typeof ConsoleProductsFeaturesListRoute
  '/console/products/privileges/list': typeof ConsoleProductsPrivilegesListRoute
  '/console/products/templates/add': typeof ConsoleProductsTemplatesAddRoute
  '/console/products/templates/list': typeof ConsoleProductsTemplatesListRoute
  '/console/roles/edit/$id': typeof ConsoleRolesEditIdRoute
  '/console/sites/edit/$id': typeof ConsoleSitesEditIdRoute
  '/console/sites/licenses/add': typeof ConsoleSitesLicensesAddRoute
  '/console/sites/licenses/list': typeof ConsoleSitesLicensesListRoute
  '/console/products/features/edit/$id': typeof ConsoleProductsFeaturesEditIdRoute
  '/console/products/templates/duplicate/$id': typeof ConsoleProductsTemplatesDuplicateIdRoute
  '/console/products/templates/edit/$id': typeof ConsoleProductsTemplatesEditIdRoute
  '/console/sites/licenses/duplicate/$id': typeof ConsoleSitesLicensesDuplicateIdRoute
  '/console/sites/licenses/edit/$id': typeof ConsoleSitesLicensesEditIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/console'
    | '/console/dashboard'
    | '/console/no-permission'
    | '/console/'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/console/distributor/add'
    | '/console/distributor/list'
    | '/console/divisions/list'
    | '/console/integrator/add'
    | '/console/integrator/list'
    | '/console/operator-groups/add'
    | '/console/operator-groups/list'
    | '/console/qr/list'
    | '/console/roles/add'
    | '/console/roles/assign'
    | '/console/roles/list'
    | '/console/sites/add'
    | '/console/sites/list'
    | '/console/distributor/edit/$id'
    | '/console/integrator/edit/$id'
    | '/console/operator-groups/edit/$id'
    | '/console/products/features/add'
    | '/console/products/features/list'
    | '/console/products/privileges/list'
    | '/console/products/templates/add'
    | '/console/products/templates/list'
    | '/console/roles/edit/$id'
    | '/console/sites/edit/$id'
    | '/console/sites/licenses/add'
    | '/console/sites/licenses/list'
    | '/console/products/features/edit/$id'
    | '/console/products/templates/duplicate/$id'
    | '/console/products/templates/edit/$id'
    | '/console/sites/licenses/duplicate/$id'
    | '/console/sites/licenses/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/console/dashboard'
    | '/console/no-permission'
    | '/console'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/console/distributor/add'
    | '/console/distributor/list'
    | '/console/divisions/list'
    | '/console/integrator/add'
    | '/console/integrator/list'
    | '/console/operator-groups/add'
    | '/console/operator-groups/list'
    | '/console/qr/list'
    | '/console/roles/add'
    | '/console/roles/assign'
    | '/console/roles/list'
    | '/console/sites/add'
    | '/console/sites/list'
    | '/console/distributor/edit/$id'
    | '/console/integrator/edit/$id'
    | '/console/operator-groups/edit/$id'
    | '/console/products/features/add'
    | '/console/products/features/list'
    | '/console/products/privileges/list'
    | '/console/products/templates/add'
    | '/console/products/templates/list'
    | '/console/roles/edit/$id'
    | '/console/sites/edit/$id'
    | '/console/sites/licenses/add'
    | '/console/sites/licenses/list'
    | '/console/products/features/edit/$id'
    | '/console/products/templates/duplicate/$id'
    | '/console/products/templates/edit/$id'
    | '/console/sites/licenses/duplicate/$id'
    | '/console/sites/licenses/edit/$id'
  id:
    | '__root__'
    | '/'
    | '/console'
    | '/(public)'
    | '/(public)/_public'
    | '/console/dashboard'
    | '/console/no-permission'
    | '/console/'
    | '/(public)/_public/forgot-password'
    | '/(public)/_public/reset-password'
    | '/(public)/_public/sign-in'
    | '/console/distributor/add'
    | '/console/distributor/list'
    | '/console/divisions/list'
    | '/console/integrator/add'
    | '/console/integrator/list'
    | '/console/operator-groups/add'
    | '/console/operator-groups/list'
    | '/console/qr/list'
    | '/console/roles/add'
    | '/console/roles/assign'
    | '/console/roles/list'
    | '/console/sites/add'
    | '/console/sites/list'
    | '/console/distributor/edit/$id'
    | '/console/integrator/edit/$id'
    | '/console/operator-groups/edit/$id'
    | '/console/products/features/add'
    | '/console/products/features/list'
    | '/console/products/privileges/list'
    | '/console/products/templates/add'
    | '/console/products/templates/list'
    | '/console/roles/edit/$id'
    | '/console/sites/edit/$id'
    | '/console/sites/licenses/add'
    | '/console/sites/licenses/list'
    | '/console/products/features/edit/$id'
    | '/console/products/templates/duplicate/$id'
    | '/console/products/templates/edit/$id'
    | '/console/sites/licenses/duplicate/$id'
    | '/console/sites/licenses/edit/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConsoleRoute: typeof ConsoleRouteWithChildren
  publicRoute: typeof publicRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConsoleRoute: ConsoleRouteWithChildren,
  publicRoute: publicRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/console",
        "/(public)"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/console": {
      "filePath": "console.tsx",
      "children": [
        "/console/dashboard",
        "/console/no-permission",
        "/console/",
        "/console/distributor/add",
        "/console/distributor/list",
        "/console/divisions/list",
        "/console/integrator/add",
        "/console/integrator/list",
        "/console/operator-groups/add",
        "/console/operator-groups/list",
        "/console/qr/list",
        "/console/roles/add",
        "/console/roles/assign",
        "/console/roles/list",
        "/console/sites/add",
        "/console/sites/list",
        "/console/distributor/edit/$id",
        "/console/integrator/edit/$id",
        "/console/operator-groups/edit/$id",
        "/console/products/features/add",
        "/console/products/features/list",
        "/console/products/privileges/list",
        "/console/products/templates/add",
        "/console/products/templates/list",
        "/console/roles/edit/$id",
        "/console/sites/edit/$id",
        "/console/sites/licenses/add",
        "/console/sites/licenses/list",
        "/console/products/features/edit/$id",
        "/console/products/templates/duplicate/$id",
        "/console/products/templates/edit/$id",
        "/console/sites/licenses/duplicate/$id",
        "/console/sites/licenses/edit/$id"
      ]
    },
    "/(public)": {
      "filePath": "(public)",
      "children": [
        "/(public)/_public"
      ]
    },
    "/(public)/_public": {
      "filePath": "(public)/_public.tsx",
      "parent": "/(public)",
      "children": [
        "/(public)/_public/forgot-password",
        "/(public)/_public/reset-password",
        "/(public)/_public/sign-in"
      ]
    },
    "/console/dashboard": {
      "filePath": "console/dashboard.tsx",
      "parent": "/console"
    },
    "/console/no-permission": {
      "filePath": "console/no-permission.tsx",
      "parent": "/console"
    },
    "/console/": {
      "filePath": "console/index.tsx",
      "parent": "/console"
    },
    "/(public)/_public/forgot-password": {
      "filePath": "(public)/_public/forgot-password.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/reset-password": {
      "filePath": "(public)/_public/reset-password.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/sign-in": {
      "filePath": "(public)/_public/sign-in.tsx",
      "parent": "/(public)/_public"
    },
    "/console/distributor/add": {
      "filePath": "console/distributor/add.tsx",
      "parent": "/console"
    },
    "/console/distributor/list": {
      "filePath": "console/distributor/list.tsx",
      "parent": "/console"
    },
    "/console/divisions/list": {
      "filePath": "console/divisions/list.tsx",
      "parent": "/console"
    },
    "/console/integrator/add": {
      "filePath": "console/integrator/add.tsx",
      "parent": "/console"
    },
    "/console/integrator/list": {
      "filePath": "console/integrator/list.tsx",
      "parent": "/console"
    },
    "/console/operator-groups/add": {
      "filePath": "console/operator-groups/add.tsx",
      "parent": "/console"
    },
    "/console/operator-groups/list": {
      "filePath": "console/operator-groups/list.tsx",
      "parent": "/console"
    },
    "/console/qr/list": {
      "filePath": "console/qr/list.tsx",
      "parent": "/console"
    },
    "/console/roles/add": {
      "filePath": "console/roles/add.tsx",
      "parent": "/console"
    },
    "/console/roles/assign": {
      "filePath": "console/roles/assign.tsx",
      "parent": "/console"
    },
    "/console/roles/list": {
      "filePath": "console/roles/list.tsx",
      "parent": "/console"
    },
    "/console/sites/add": {
      "filePath": "console/sites/add.tsx",
      "parent": "/console"
    },
    "/console/sites/list": {
      "filePath": "console/sites/list.tsx",
      "parent": "/console"
    },
    "/console/distributor/edit/$id": {
      "filePath": "console/distributor/edit/$id.tsx",
      "parent": "/console"
    },
    "/console/integrator/edit/$id": {
      "filePath": "console/integrator/edit/$id.tsx",
      "parent": "/console"
    },
    "/console/operator-groups/edit/$id": {
      "filePath": "console/operator-groups/edit/$id.tsx",
      "parent": "/console"
    },
    "/console/products/features/add": {
      "filePath": "console/products/features/add.tsx",
      "parent": "/console"
    },
    "/console/products/features/list": {
      "filePath": "console/products/features/list.tsx",
      "parent": "/console"
    },
    "/console/products/privileges/list": {
      "filePath": "console/products/privileges/list.tsx",
      "parent": "/console"
    },
    "/console/products/templates/add": {
      "filePath": "console/products/templates/add.tsx",
      "parent": "/console"
    },
    "/console/products/templates/list": {
      "filePath": "console/products/templates/list.tsx",
      "parent": "/console"
    },
    "/console/roles/edit/$id": {
      "filePath": "console/roles/edit/$id.tsx",
      "parent": "/console"
    },
    "/console/sites/edit/$id": {
      "filePath": "console/sites/edit/$id.tsx",
      "parent": "/console"
    },
    "/console/sites/licenses/add": {
      "filePath": "console/sites/licenses/add.tsx",
      "parent": "/console"
    },
    "/console/sites/licenses/list": {
      "filePath": "console/sites/licenses/list.tsx",
      "parent": "/console"
    },
    "/console/products/features/edit/$id": {
      "filePath": "console/products/features/edit/$id.tsx",
      "parent": "/console"
    },
    "/console/products/templates/duplicate/$id": {
      "filePath": "console/products/templates/duplicate/$id.tsx",
      "parent": "/console"
    },
    "/console/products/templates/edit/$id": {
      "filePath": "console/products/templates/edit/$id.tsx",
      "parent": "/console"
    },
    "/console/sites/licenses/duplicate/$id": {
      "filePath": "console/sites/licenses/duplicate/$id.tsx",
      "parent": "/console"
    },
    "/console/sites/licenses/edit/$id": {
      "filePath": "console/sites/licenses/edit/$id.tsx",
      "parent": "/console"
    }
  }
}
ROUTE_MANIFEST_END */
